export function hasLogValue(value) {
	return value !== null && value !== undefined && value !== "";
}

export function didLogFieldChange(from, to) {
	const hasFrom = hasLogValue(from);
	const hasTo = hasLogValue(to);
	if (!hasFrom && !hasTo) return false;
	if (hasFrom !== hasTo) return true;
	return from !== to;
}

export function getTimeRegistrationLogType(log = {}) {
	const startChanged = didLogFieldChange(log.start_from, log.start_to);
	const endChanged = didLogFieldChange(log.end_from, log.end_to);

	if (endChanged && !startChanged) return "Salida";
	if (startChanged) return "Entrada";
	if (endChanged) return "Salida";

	if (hasLogValue(log.start_from) || hasLogValue(log.start_to)) return "Entrada";
	if (hasLogValue(log.end_from) || hasLogValue(log.end_to)) return "Salida";
	return "";
}

export function getTimeRegistrationLogRange(log = {}) {
	const type = getTimeRegistrationLogType(log);
	if (type === "Entrada") {
		return { from: log.start_from, to: log.start_to };
	}
	if (type === "Salida") {
		return { from: log.end_from, to: log.end_to };
	}
	return null;
}
